import React from 'react';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import Icon from '../../../../Assets/Icon/CustomIcon';
import { Badge } from '../../../../Components/Ui/Badge';
import ExtendBottomSheet from './ExtendBottomSheet';
export const statusBadgeClass = {
  반려: 'bg-red-400',
  연장반려: 'bg-rose-500',
  만료: 'bg-slate-900',
  결재요청: 'bg-primary',
  승인요청: 'bg-emerald-600',
  결재대기: 'bg-blue-400',
  결재완료: 'bg-indigo-500',
  연장요청: 'bg-blue-300',
  연장대기: 'bg-pink-400',
  입회요청: 'bg-orange-500',
  입회중: 'bg-amber-500',
  작업완료: 'bg-slate-400',
  대기: 'bg-slate-300',
};
export default function PermitList({ data, SaveLogic1 }) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const canShowWitness = (status) => {
    const afterApproval = [
      '입회중',
      '입회요청',
      '연장요청',
      '연장대기',
      '연장반려',
      '작업완료',
      '만료',
    ];
    return afterApproval.includes(status);
  };

  const canShowExtend = (item) => {
    const extendableStatus = ['입회중', '입회요청', '연장반려'];
    const isStatusReady = extendableStatus.includes(item.status);

    const isOwner = String(item.reqId) === String(userInfo?.decUserId);
    const isAlreadyAllExtended = item.allExtendedYn === 'Y';
    return isStatusReady && isOwner && !isAlreadyAllExtended;
  };

  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-base leading-relaxed text-slate-500">
          현재 선택한 날짜에 작업허가서가 없습니다.
          <br />
          아래 버튼을 눌러 작성해주세요.
        </p>
      </div>
    );
  }

  return (
    <>
      <ul className="flex flex-col gap-3 pb-4">
        {data.map((item) => (
          <li
            key={item.pmCd}
            onClick={() => {
              dispatch(CommonActions.increaseStep());

              navigate(`/M_Permit/detail/${item.pmCd}`, {
                state: { from: '/M_Permit' },
              });
            }}
            className="group bg-card-light shadow-soft relative flex cursor-pointer items-start gap-4 rounded-xl border border-slate-100 p-4 transition-all"
          >
            <div className="relative shrink-0">
              <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-100">
                <span className="material-symbols-rounded text-3xl text-slate-300">
                  <Icon.User />
                </span>
              </div>
              <span
                className={`text-2xs absolute -bottom-1 left-1/2 z-10 -translate-x-1/2 rounded-full px-2 py-0.5 font-bold whitespace-nowrap text-white shadow-sm ${
                  statusBadgeClass[item.status] || 'bg-slate-500'
                }`}
              >
                {item.status}
              </span>
            </div>

            <div className="flex min-w-0 flex-1 flex-col pt-0.5">
              <div className="mb-0.5 flex items-start justify-between">
                <p className="truncate pr-2 font-bold text-slate-900">
                  {item.reqNm}
                </p>
                <span className="shrink-0 text-sm font-bold text-slate-900">
                  {item.strTime} ~ {item.endTime}
                </span>
              </div>

              <p className="mb-2 truncate text-xs text-slate-500">
                {item.workContent}
              </p>

              <div className="flex flex-wrap items-center gap-1.5">
                {item.workItems?.split(',').map((type, index) => (
                  <Badge key={index} label={type.trim()} />
                ))}
              </div>

              {(canShowWitness(item.status) || canShowExtend(item)) && (
                <>
                  <div className="my-3 border-b border-[#becab7]/20" />
                  <div className="flex w-full gap-2">
                    {canShowWitness(item.status) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(CommonActions.increaseStep());
                          navigate(`/M_Permit/detail/${item.pmCd}`, {
                            state: { from: '/M_Permit', mode: 'witness' },
                          });
                        }}
                        className="flex-1 rounded-sm bg-[#5ABD4F] py-2.5 text-xs font-bold text-white transition-colors active:opacity-80"
                      >
                        입회하기
                      </button>
                    )}

                    {canShowExtend(item) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(PermitActions.setExtendData(item));
                          navigate(`/M_Permit/extand/${item.pmCd}`);
                        }}
                        className="flex-1 rounded-sm bg-slate-100 py-2.5 text-xs font-bold text-slate-600 transition-colors active:bg-slate-200"
                      >
                        연장하기
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </li>
        ))}
      </ul>

      {/* 바텀시트 */}
      {bottomSheetState.type === 'extend' && (
        <ExtendBottomSheet SaveLogic1={SaveLogic1} />
      )}
    </>
  );
}
